import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DriverRunEntry, FPAnalysisData } from "../types/fpAnalysis";

interface FPAnalysisState extends FPAnalysisData {
  highlightWetPeriod: boolean;
  wetPeriodRange: [number, number];
}

const initialState: FPAnalysisState = {
  driverRuns: {},
  isFullWetSession: false,
  highlightWetPeriod: false,
  wetPeriodRange: [0, 45],
};

export const fpAnalysisSlice = createSlice({
  name: "fpAnalysis",
  initialState,
  reducers: {
    setFPAnalysisData: (state, action) => {
      const fpAnalysisData = action.payload;
      if (fpAnalysisData.reset) {
        state.driverRuns = {};
        state.isFullWetSession = false;
        return;
      }
      fpAnalysisData.driverRuns?.forEach(
        (entry: {
          driver: string;
          runs: (Omit<DriverRunEntry, "loopSectors"> & {
            loopSectors?: { loop: string; time: number }[];
          })[];
        }) => {
          state.driverRuns[entry.driver] = entry.runs.map((run) => ({
            ...run,
            loopSectors: run.loopSectors
              ? Object.fromEntries(
                  run.loopSectors.map((ls) => [ls.loop, ls.time]),
                )
              : {},
          }));
        },
      );
      if (typeof fpAnalysisData.isFullWetSession === "boolean") {
        state.isFullWetSession = fpAnalysisData.isFullWetSession;
      }
      if (typeof fpAnalysisData.highlightWetPeriod === "boolean") {
        state.highlightWetPeriod = fpAnalysisData.highlightWetPeriod;
      }
      if (Array.isArray(fpAnalysisData.wetPeriodRange)) {
        state.wetPeriodRange = fpAnalysisData.wetPeriodRange;
      }
    },
    setHighlightWetPeriod: (state, action) => {
      state.highlightWetPeriod = action.payload;
    },
    setWetPeriodRange: (state, action) => {
      state.wetPeriodRange = action.payload;
    },
  },
});

export const { setFPAnalysisData, setHighlightWetPeriod, setWetPeriodRange } =
  fpAnalysisSlice.actions;
export default fpAnalysisSlice.reducer;
